import { render, staticRenderFns } from "./WpItemsEdit.vue?vue&type=template&id=511eb52f&"
import script from "./WpItemsEdit.vue?vue&type=script&lang=js&"
export * from "./WpItemsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports